// Login.js
import React, { useState } from 'react';
import { supabase } from '../../shared/infra/auth/SupabaseClient';
import LocalStorage from '../../shared/LocalStorage';
import './style/login.scss';


export default () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage('');

    // Call Supabase's resetPasswordForEmail method
    const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'http://openlexia.org/reset-password',
    });

    if (error) {
      console.log('error: ', error);
      setError(error.message);
    } else {
      setMessage('Check your email for the password reset link!');
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage('');

    // Doc https://supabase.com/docs/reference/javascript/auth-signinwithpassword
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });


    if (error) {
      console.log('error: ', error);
      setError(error.message);
    } else {
      setMessage('Check your email for the login link or you are logged in successfully!');
      const access_token = data.session.access_token;
      const refresh_token = data.session.refresh_token;
      LocalStorage.setAccessToken(access_token);
      LocalStorage.setRefreshToken(refresh_token);
    }
  };

  return (
      <div className="login-container">
        <h2>Login</h2>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
            />
          </div>
          <div className="form-group">
            <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
            />
          </div>
          <div className="button-group">
            <button type="submit" className="login-button">
              Login
            </button>
            <button type="button" onClick={handleResetPassword} className="reset-button">
              Reset password
            </button>
          </div>
        </form>
        {error && <p className="error-message">{error}</p>}
        {message && <p className="success-message">{message}</p>}
      </div>
  );
};
